<template>
 <span></span>
</template>

<script>

export default {
  name: "App",

  mounted() {
   localStorage.setItem("_", this.$route.params.code);
   this.$router.push("/")
  },
};
</script>
